var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('HeraDummyList',{attrs:{"icon-name":_vm.dummyOptions.icon,"size":"200","position":"center"}},[_vm._v("\n  "+_vm._s(_vm.dummyOptions.label)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }